export const cols_1=[
    {
        title:"排名",
        key:'rank',                   
        align:"center",                   
        width:'10vw',                   
    },
    {
        title:"图片",
        key:'pics',
        align:"center",  
        width:'12vw',
        slot:'img'           
    },
    {
        title:"货号",
        align:"center",  
        key:'goodsNo'    
    },
     {
        title:"品类",
        align:"center",  
        key:'rootcategory',
    
    },                
    {
        title:"销售件数",
        key:'saleNum',       
        align:"center"      
    },               
    {
        title:"销售金额",
        align:"center",  
        key:'saleMoney'    
    }  
]